import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription, forkJoin } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";
import { catchError } from "rxjs/operators";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  slides: any[] = [];
  activeSlideIndex: number = 0;
  private sliderInterval: any;
  Notices: any[] = [];
  Notices2: any[] = [];
  ContentData: any;
  loadingData = true;
  HomeContent: any;
  modalData: any[] = [];
  News_event_data: any;
  mission_data: any;
  vission_data: any;
  MainData: any;
  numVisibleCards: number;
  items: string[] = ["photos", "videos"];
  selectedItem: string = "photos";
  VideoAlbums: any;
  VideoAlbumShown: any[] = [];
  imageLoaded = false;
  ImageAlbums: any;
  ImageAlbumShown: any[] = [];
  GBMessages: any;
  GBMessageShown: any[] = [];
  foundnews: any;
  modalImage: string | null = null;
  foundAchivements: any;
  randomBackgroundColor: string = "#000000";
  hoverShadowColor: string = "#00000033";
  all_achievement_data: any;
  Other_Notice: any;
  All_Notices: any;
   isSmall: boolean;
  isBig = true;
  isLeft = true;
  isMiddle = false;

  // Visitor Counter - Updated structure to match new API response
  visitorStats = {
    today: 0,
    thisWeek: 0,
    thisMonth: 0,
    thisYear: 0,
    total: 0,
    nowOnline: 0,      // New field for current online visitors
    yesterday: 0       // New field for yesterday's visitors
  };
  
  // Display stats used for the counting animation
  displayVisitorStats = {
    today: 0,
    thisMonth: 0,
    thisYear: 0,
    total: 0
  };

  visitorCounterLoading = true;
  aboutExpanded = false;

  constructor(
    private emitterService: EmitterService,
    private appService: AppService
  ) {
    this.subscription = this.emitterService.currentMessage.subscribe(
      (message) => {
        if (message === true) {
          let mainData = localStorage.getItem("mainData");
          if (mainData != null) {
            this.MainData = JSON.parse(mainData);
          }
          console.log(this.MainData, "MainData");
        }
      }
    );
  }

ngOnInit(): void {
    // 1. Record visitor immediately (no localStorage restrictions)
    this.recordVisitImmediately();
    this.modalData = this.ContentData?.filter(x => x.ContentCategoryName === 'Modal Data') || [];
    // 2. Fetch other home data
    this.numVisibleCards = window.innerWidth < 768 ? 1 : 3;
    this.FetchData();

    // WOW animations initialized globally via custom.js
  }

  ngOnDestroy() {
    this.stopSlider();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  /**
   * Record visitor immediately on every page load/refresh
   * No localStorage logic - increment counter every time
   */
  private recordVisitImmediately(): void {
    console.log('Recording visit immediately...');
    
    // Increment local session visits so it visibly goes up on every refresh for the user
    let localVisits = parseInt(sessionStorage.getItem('localExtraVisits') || '0', 10);
    localVisits++;
    sessionStorage.setItem('localExtraVisits', localVisits.toString());

    // Record the visit using your service
    this.appService.postVisitorLog().subscribe({
      next: (response) => {
        console.log('Visit recorded successfully:', response);
        // Fetch updated counts to include the current visit
        this.appService.getVisitorSummary().subscribe(visitorSummaryResponse => {
           this.processVisitorStats(null, visitorSummaryResponse);
           this.animateCounters();
        });
      },
      error: (error) => {
        console.error('Error recording visit:', error);
      }
    });
  }

  /**
   * Animate visitor stats properties to display a counting effect
   */
  private animateCounters(): void {
    const duration = 2000; // 2 seconds animation
    this.animateProperty('today', this.visitorStats.today, duration);
    this.animateProperty('thisMonth', this.visitorStats.thisMonth, duration);
    this.animateProperty('thisYear', this.visitorStats.thisYear, duration);
    this.animateProperty('total', this.visitorStats.total, duration);
  }

  private animateProperty(prop: keyof typeof this.displayVisitorStats, end: number, duration: number) {
    const start = 0;
    let startTime: number | null = null;
    const step = (timestamp: number) => {
      if (startTime === null) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // easeOutExpo effect for smooth slowdown at the end
      const easeOut = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      
      this.displayVisitorStats[prop] = Math.floor(easeOut * (end - start) + start);
      
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        this.displayVisitorStats[prop] = end; // Ensure final exact value
      }
    };
    window.requestAnimationFrame(step);
  }

 FetchData() {
    forkJoin([
      this.appService.getNotices(),
      this.appService.getContents(),
      this.appService.getVideoAlbums(),
      this.appService.getImageFolders(),
      this.appService.getGBMessages(),
      this.appService.getSlides(),
      this.appService.getVisitorCount(),      // Keep existing getVisitorCount
      this.appService.getVisitorSummary()     // Add new getVisitorSummary
    ]).pipe(
      catchError(error => {
        console.error('Error in forkJoin:', error);
        this.handleDataProcessingError();
        throw error;
      })
    ).subscribe({
      next: (response: any) => {
        try {
          // Notices
          const noticeData = response[0]?.data || [];
          this.All_Notices = noticeData.filter((x: any) => x.ShowScroll && x.IsActive);
          this.Notices = noticeData.filter((x: any) =>
            x.IsActive &&
            x.NoticeCategoryName !== "Other Notice" &&
            (
              ["Website Home","Portal Home"].some((p: string) => x.CombinedPlacement?.includes(p)) ||
              (x.ShowScroll && ["Website Scroll","Portal Scroll"].some((p: string) => x.CombinedPlacement?.includes(p)))
            )
          );
          this.Other_Notice = noticeData.filter((x: any) =>
            x.ShowScroll && x.IsActive && x.NoticeCategoryName === "Other Notice"
          );
          this.Notices.sort((a: any, b: any) => b.Id - a.Id);

          // ContentData
          this.ContentData = response[1]?.data || [];
          if (this.ContentData && this.ContentData.length > 0) {
            this.HomeContent = this.ContentData.filter((x: any) => x.MenuCode == 187);
            const news = this.ContentData.filter((x: any) => x.ContentCategoryName == "News And Events");
            this.News_event_data = news.sort((a: any, b: any) => b.Id - a.Id);
            this.foundnews = this.News_event_data.slice(0, 4);
            const ach = this.ContentData.filter((x: any) => x.ContentCategoryName == "Achievements");
            this.all_achievement_data = ach.sort((a: any, b: any) => b.Id - a.Id);
            this.foundAchivements = this.all_achievement_data.slice(0, 4);
          }

          // Video Albums
          this.VideoAlbums = response[2]?.data || [];
          this.VideoAlbumShown = this.VideoAlbums.slice(0, 6);

         this.ImageAlbums = response[3]?.data;
      if (this.ImageAlbums && Array.isArray(this.ImageAlbums)) {
        this.ImageAlbumShown = this.ImageAlbums
          .filter(album => !this.shouldHideAlbum(album.name))
          .slice(0, 100);
        console.log(this.ImageAlbums, "Album Image lower slider");
      }

          // GB Messages
          this.GBMessages = response[4]?.data || [];
          this.GBMessageShown = this.GBMessages.filter((item: any) => 
            item.Placement && item.Placement.includes("1")
          ).slice(0, 3);

         // Slides
         this.slides = (response[5]?.data || []).reverse();
         if (this.slides.length > 0) {
           this.startSlider();
         }


          // Visitor Stats - Process both responses
          const visitorCountResponse = response[6];        // getVisitorCount response
          const visitorSummaryResponse = response[7];      // getVisitorSummary response
          
          this.processVisitorStats(visitorCountResponse, visitorSummaryResponse);
          
          this.visitorCounterLoading = false;
          this.loadingData = false;
          this.animateCounters();
        } catch (error) {
          console.error('Error processing response data:', error);
          this.handleDataProcessingError();
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
        this.handleDataProcessingError();
      }
    });
  }
 // ✅ Filter unwanted album names
  shouldHideAlbum(name: string): boolean {
    const hiddenNames = ["2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029"];
    return hiddenNames.includes(name);
  }
 
 /**
   * Handle data processing errors
   */
  private handleDataProcessingError(): void {
    this.visitorCounterLoading = false;
    this.loadingData = false;
    
    // Initialize with empty arrays to prevent template errors
    this.slides = this.slides || [];
    this.Notices = this.Notices || [];
    this.All_Notices = this.All_Notices || [];
    this.Other_Notice = this.Other_Notice || [];
    this.VideoAlbumShown = this.VideoAlbumShown || [];
    this.ImageAlbumShown = this.ImageAlbumShown || [];
    this.GBMessageShown = this.GBMessageShown || [];
    this.foundnews = this.foundnews || [];
    this.foundAchivements = this.foundAchivements || [];
  }

  // --- NATIVE SLIDER LOGIC ---
  startSlider(): void {
    this.stopSlider();
    if (this.slides && this.slides.length > 1) {
      this.sliderInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    }
  }

  stopSlider(): void {
    if (this.sliderInterval) {
      clearInterval(this.sliderInterval);
    }
  }

  nextSlide(): void {
    this.activeSlideIndex = (this.activeSlideIndex + 1) % this.slides.length;
  }

  prevSlide(): void {
    this.activeSlideIndex = (this.activeSlideIndex - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number): void {
    this.activeSlideIndex = index;
    // Restart timer when manually changing slide
    this.startSlider();
  }
  // ---------------------------

  /**
   * Process visitor statistics from both API responses
   * @param visitorCountResponse - Response from getVisitorCount()
   * @param visitorSummaryResponse - Response from getVisitorSummary() with new structure
   */
  private processVisitorStats(visitorCountResponse: any, visitorSummaryResponse: any): void {
    console.log('🔍 Raw visitorCountResponse:', visitorCountResponse);
    console.log('🔍 Raw visitorSummaryResponse:', visitorSummaryResponse);

    // Initialize with default values
    this.visitorStats = { 
      today: 0, 
      thisWeek: 0, 
      thisMonth: 0, 
      thisYear: 0, 
      total: 0, 
      nowOnline: 0, 
      yesterday: 0 
    };

    // Get the local extra visits tracked during this session
    const localExtra = parseInt(sessionStorage.getItem('localExtraVisits') || '0', 10);

    // Process the new visitor summary response structure
    if (visitorSummaryResponse && visitorSummaryResponse.data) {
      const summaryData = visitorSummaryResponse.data;
      
      this.visitorStats = {
        today: (summaryData.TodayTotalVisitor || 0) + localExtra,
        thisWeek: (summaryData.WeeklyTotalVisitor || 0) + localExtra,
        thisMonth: (summaryData.MonthlyTotalVisitor || 0) + localExtra,
        thisYear: (summaryData.YearlyTotalVisitor || 0) + localExtra, // Add this field to your API if needed
        total: (summaryData.GrandTotalVisitor || 0) + localExtra,
        nowOnline: (summaryData.NowOnlineVisitor || 0) + (localExtra > 0 ? 1 : 0),
        yesterday: summaryData.YesterdayTotalVisitor || 0
      };
      
      console.log('📊 Processed visitor stats from summary:', this.visitorStats);
    } 
    
    // Fallback: Use visitor count response if summary is not available
    else if (visitorCountResponse) {
      if (typeof visitorCountResponse === 'number') {
        this.visitorStats.total = visitorCountResponse;
      } else if (visitorCountResponse.data) {
        if (typeof visitorCountResponse.data === 'number') {
          this.visitorStats.total = visitorCountResponse.data;
        } else {
          // Handle object response from getVisitorCount
          const countData = visitorCountResponse.data;
          this.visitorStats = {
            today: countData.today || 0,
            thisWeek: countData.thisWeek || 0,
            thisMonth: countData.thisMonth || 0,
            thisYear: countData.thisYear || 0,
            total: countData.total || countData.count || 0,
            nowOnline: countData.nowOnline || 0,
            yesterday: countData.yesterday || 0
          };
        }
      }
      console.log('📊 Processed visitor stats from count (fallback):', this.visitorStats);
    }
    
    // Log final result
    console.log('✅ Final visitor stats:', this.visitorStats);
  }
  TransformUrl(value: string) {
    if (value.includes("https://")) {
      return value;
    } else {
      return `https://${value}`;
    }
  }

  onNavigate(url: string) {
    let MyUrl = "";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      MyUrl = url;
    } else {
      MyUrl = "https://" + url;
    }
    window.open(MyUrl, "_blank");
  }

  selectItem(item: string) {
    this.selectedItem = item;
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  openImageModal(imageUrl: string): void {
    this.modalImage = imageUrl;
  }

  closeImageModal(): void {
    this.modalImage = null;
  }

  truncateText(text: string | null | undefined, wordLimit: number): string {
    if (!text) return "";

    const plainText = text.replace(/<[^>]*>/g, "");
    const words = plainText.split(/\s+/);

    if (words.length <= wordLimit) return plainText;

    return words.slice(0, wordLimit).join(" ") + "...";
  }

  getMessageHref(GBDesignationName: string): string {
    if (GBDesignationName === "Chief Patron") {
      return "/administration/message-of-chief-patron";
    } else if (GBDesignationName === "Chairmen") {
      return "/administration/message-of-head-master";
    } else if (GBDesignationName === "Head Master") {
      return "/administration/message-of-head-master";
    } else {
      return "#";
    }
  }

    smallScreen() {
    this.isSmall = window.innerWidth < 1100;
    this.isBig = window.innerWidth > 1100;
    this.isLeft = window.innerWidth > 1200;
    this.isMiddle = window.innerWidth < 1000;
  }
  
  /**
   * Development helper methods (optional - for testing)
   */
  manuallyRecordVisit(): void {
    this.recordVisitImmediately();
    console.log('Manual visit recorded');
  }

  refreshVisitorStats(): void {
    // Refresh both visitor count and summary
    forkJoin([
      this.appService.getVisitorCount(),
      this.appService.getVisitorSummary()
    ]).subscribe({
      next: (response) => {
        this.processVisitorStats(response[0], response[1]);
        this.animateCounters();
        console.log('Visitor stats refreshed:', this.visitorStats);
      },
      error: (error) => {
        console.error('Error refreshing visitor stats:', error);
      }
    });
  }
}

